import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const ResponseChart = ({ data }) => {
  // Custom tooltip component for better styling
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 shadow-lg border border-gray-100 rounded-lg">
          <p className="text-gray-600 font-medium">{label}</p>
          <p className="text-blue-600 font-semibold">
            {payload[0].value} responses
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-white rounded-xl p-6  ">
   
      
      <ResponsiveContainer width="100%" height={280}>
        <LineChart data={data} margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
          <CartesianGrid 
            strokeDasharray="0" 
            stroke="#f3f4f6" 
            vertical={false}
          />
          <XAxis 
            dataKey="date" 
            axisLine={false}
            tickLine={false}
            tick={{ fill: '#6b7280', fontSize: 12 }}
            padding={{ left: 10, right: 10 }}
          />
          <YAxis 
            axisLine={false}
            tickLine={false}
            tick={{ fill: '#6b7280', fontSize: 12 }}
            width={40}
          />
          <Tooltip content={<CustomTooltip />} />
          <Line
            type="monotone"
            dataKey="responses"
            stroke="url(#colorGradient)"
            strokeWidth={3}
            dot={false}
            activeDot={{ 
              r: 6, 
              fill: '#0066FF',
              stroke: '#ffffff',
              strokeWidth: 2,
              
            }}
          />
          {/* Gradient definition for the line */}
          <defs>
            <linearGradient id="colorGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#0066FF" />
            </linearGradient>
          </defs>
        </LineChart>
      </ResponsiveContainer>
      
      <div className="flex justify-between items-center mt-4 pt-4 border-t border-gray-100">
        <p className="text-xs text-gray-500">
          Last updated: {new Date().toLocaleDateString()}
        </p>
      </div>
    </div>
  );
};

export default ResponseChart;